import {Button, Modal} from "react-bootstrap";
import {Link, Navigate} from "react-router-dom";
import StarIcon from "../../../images/icons/starIcon";
import ImageComponent from "../shared/ImageComponent";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import NoProfile from "../../../images/profileImage.png";
import {useBlockedUsers} from "../../../hooks/useGetUser";
import Loader from "../shared/Loader";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";
import BlockModal from "../shared/blockModal";
import {useState} from "react";
import {userRoleList} from "../../../utils/constants";

const ListBlockedUsersModal = ({show, handleClose}) => {
  const {data: blockedUsers, isError, isLoading, error} = useBlockedUsers();
  const [unblockModal, setUnblockModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const {onUnBlockUser} = useUpdateTechnician();
  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return <Navigate to="/" />;
  }

  if (blockedUsers) {
  }
  return (
    <>
      <BlockModal
        success={true}
        show={unblockModal}
        setShow={setUnblockModal}
        openListBlock={handleClose}
        title={`Débloquer ${selectedUser?.firstName} ?`}
        message={`${
          selectedUser?.selectedRole === userRoleList.TECHNICIAN
            ? "Êtes-vous sûr de vouloir débloquer cet utilisateur? Il pourra à nouveau  voir vos annonces et vous envoyer des messages. "
            : "Êtes-vous sûr de vouloir débloquer cet utilisateur? Il pourra à nouveau interagir avec vous et vous envoyer des messages."
        } `}
        handleButton={() => {
          onUnBlockUser({blockedId: selectedUser?.id});
          setUnblockModal(false);
          handleClose(true);
        }}
      />
      <Modal
        className="modal fade"
        show={show}
        onHide={handleClose}
        centered
        size="lg"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title text-[#1A64B9] font-semibold">
              Liste des utilisateurs bloqués
            </h4>
            <Button
              variant=""
              type="button"
              className="close"
              onClick={() => handleClose(false)}
            >
              <span>×</span>
            </Button>
          </div>
          <div className="modal-body !py-3 !px-0 h-fit overflow-scroll overflow-style-none">
            {blockedUsers?.length ? (
              <div className="w-full flex flex-col gap-4 justify-start items-start h-fit p-4 ">
                {blockedUsers.map((user, index) => (
                  <div
                    className="w-full flex justify-between items-center  "
                    key={index}
                  >
                    <div className="flex items-center justify-start  gap-3 ">
                      <div className="relative min-w-7 w-7">
                        {!!user?.blocked?.avgRating && (
                          <div className="bg-[#FFC107] w-5 flex justify-center gap-[2px] items-center leading-none p-[1px] text-white text-[4px] absolute bottom-0 rounded-full left-[50%] -translate-x-[50%] ">
                            {Number(user?.blocked?.avgRating).toFixed(2)}
                            <StarIcon className="fill-white stroke-none w-1 h-1" />
                          </div>
                        )}
                        <ImageComponent
                          src={buildImageUrl(user?.blocked?.imageUri)}
                          alt=""
                          className=" w-7 aspect-square min-w-7 rounded-full object-cover"
                          fallback={
                            <img
                              src={NoProfile}
                              alt=""
                              className=" w-7 aspect-square min-w-7 rounded-full object-cover"
                              width="130"
                            />
                          }
                        />
                      </div>
                      <div className="flex flex-col justify-center items-start">
                        <div className="text-[#19295C] font-medium text-sm capitalize">
                          {user?.blocked?.lastName +
                            " " +
                            user?.blocked?.firstName}
                        </div>
                      </div>
                    </div>

                    <button
                      onClick={() => {
                        setSelectedUser(user?.blocked);
                        setUnblockModal(true);
                        handleClose(false);
                      }}
                      className="bg-[#1A64b9] text-white text-xs font-medium rounded-full px-3 py-1"
                    >
                      Débloquer
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <div className="p-4">Vous n'avez aucun utilisateur bloqué</div>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ListBlockedUsersModal;
